module.exports = __webpack_public_path__ + "img/newpos.26d585a2.png";